import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const CheckCircle: IconDef = {
  svg: (
    <G>
      <Path
        d="M6.25 9.99999L8.75 12.5L13.75 7.49999M18.3333 9.99999C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 9.99999C1.66667 5.39762 5.39763 1.66666 10 1.66666C14.6024 1.66666 18.3333 5.39762 18.3333 9.99999Z"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
      viewBox: '0 0 20 20',
    };
  },
};
